const ENGINEER_RANKS = [
  "Chief Engineer",
  "Second Engineer",
  "Third Engineer",
  "Fourth Engineer",
  "Fifth Engineer",
];

const DECK_OFFICER_RANKS = [
  "Chief Officer",
  "Second Officer",
  "Third Officer",
  "Fourth Officer",
];

const norm = (name) => String(name || "").trim().toLowerCase();

export const isEngineerRank = (name) =>
  ENGINEER_RANKS.some((r) => norm(r) === norm(name));

export const isDeckOfficerRank = (name) =>
  DECK_OFFICER_RANKS.some((r) => norm(r) === norm(name));

export const isChiefOfficer = (name) => norm(name) === "chief officer";

export const isChiefEngineer = (name) => norm(name) === "chief engineer";

export const isMasterRank = (name) => {
  const n = norm(name);
  return n === "captain" || n === "master";
};

/** Junior deck officers (OOW) — excludes Chief Officer and Master. */
export const isJuniorDeckOfficer = (name) =>
  isDeckOfficerRank(name) && !isChiefOfficer(name) && !isMasterRank(name);

/** Junior engine officers — excludes Chief Engineer. */
export const isJuniorEngineerOfficer = (name) =>
  isEngineerRank(name) && !isChiefEngineer(name);

export const canCreateOrbPartOne = (designationName) =>
  isEngineerRank(designationName) &&
  !isDeckOfficerRank(designationName) &&
  !isMasterRank(designationName);

export const canCreateOrbPartTwo = (designationName) =>
  isDeckOfficerRank(designationName) &&
  !isEngineerRank(designationName) &&
  !isMasterRank(designationName);

export const getDesignationName = (user) =>
  user?.designation?.designation_name ||
  user?.designation_name ||
  user?.designationName ||
  "";
